// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OX8b","name":"styles_name__qXus9","phone":"styles_phone__PdzSL"};